export namespace NProductSizeGuideModal {
    export const ID = 'product-size-guide-modal';
}
